import { IVerifySubjectPresenter } from "../controllers/VerifySubjectController";
import { VerifySubjectViewModel } from "../vms/VerifySubjectViewModel";
import { FormResponse } from "@/forms/FormResponse";
import { Translator } from "@/plugins/i18n/Translator";

export class VerifySubjectPresenter implements IVerifySubjectPresenter {
  public subject: string = "";
  public mode: string = "";

  public constructor(
    private vm: VerifySubjectViewModel,
    private trans: Translator
  ) {
    this.initTexts();
  }

  // Responses
  public set verifySubjectResponse(response: FormResponse<string>) {
    this.vm.verifySubjectRequest = response;

    if (!response.loading) {
      const error = !!response.error || !response.data;
      this.vm.errorTextVisible = error;
      this.vm.successTextVisible = !error;
    }
    this.updateDynamicTexts();
  }

  private initTexts() {
    this.vm.waitText = this.trans.t("please-wait");
    this.updateDynamicTexts();
  }

  private updateDynamicTexts() {
    const subject = this.trans.t(this.subject, this.subject);

    this.vm.title = this.trans.t("verify-subject.title", { subject });

    if (this.vm.successTextVisible) {
      if (this.mode === "insert") {
        this.vm.successText = this.trans.t("verify-subject.insert-success", {
          subject
        });
      } else {
        this.vm.successText = this.trans.t("verify-subject.remove-success", {
          subject
        });
      }
    }

    if (this.vm.errorTextVisible) {
      this.vm.errorText = this.trans.slug(
        this.vm.verifySubjectRequest.error,
        this.trans.t("verify-subject.error"),
        {
          subject
        }
      );
    }
  }
}
